<template>
  <div class="container">
    <div class="list">
      <div class="item" v-for="(item,index) in list" :key="index">
        <div class="header">
          <div class="time-area">
            <img src="../../assets/icons/time.png">
            <span>{{item.REPAIR_DATETIME}}</span>
          </div>
          <!-- <div class="type green">三包中</div> -->
        </div>
        <el-divider></el-divider>
        <div class="detail">
          <div class="desc">
            <div class="title">维修门店</div>
            <div class="content">{{item.STORE_NAME}}</div>
          </div>
          <div class="desc">
            <div class="title">维 修 人</div>
            <div class="content">{{item.REPAIRER}}</div>
          </div>
          <div class="desc">
            <div class="title">更 换 前</div>
            <div class="content">{{item.OLD_SB_NO && item.OLD_SB_NO!='null'?item.OLD_SB_NO:''}}</div>
          </div>
          <div class="desc">
            <div class="title">更 换 后</div>
            <div class="content">{{item.NEW_SB_NO && item.NEW_SB_NO!='null'?item.NEW_SB_NO:''}}</div>
          </div>
          <div class="desc">
            <div class="title">故障描述</div>
            <div class="content">{{item.REMAR1}}</div>
          </div>
          <div class="desc">
            <div class="title">维修内容</div>
            <div class="content">{{item.REMAR2}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {RepairHistory} from '../../apis/sanbao'
export default {
  name:'saobaoDetail',
  data(){
    return {
      list:[]
    }
  },
  methods:{
    _RepairHistory(){
      let params = {
        vid:this.$route.query.vid,
        itemId:this.$route.query.itemId,
        ownerId:this.$route.query.ownerId
      }
      RepairHistory(params).then(res=>{
        this.list = res.data
      })
    }
  },
  mounted(){
    this._RepairHistory()
  }
}
</script>

<style lang="scss" scoped>
  .container{
    width:100%;
    height:100vh;
    overflow: scroll;
    background: #f7f7f7;
  }
  .list{
    padding:0.9375rem;
    .item{
      padding:0.9375rem;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      margin-bottom:0.9375rem;
      background: #fff;
      .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .time-area{
          display: flex;
          align-items: center;
          img{
            width:1.25rem;
          }
          span{
            font-size:1.0625rem;
            color:#333;
            font-weight: bold;
            margin-left:0.625rem;
          }
        }
        .type{
          width:3.75rem;
          height:1.5rem;
          line-height: 1.5rem;
          font-size:12px;
          text-align: center;
          border-radius: 4px;
        }
        .green{
          background:#EBF9EF;
          color:#48CE70;
        }
        .blue{
          background:#EEF4FF;
          color:#5B92FF;
        }
      }
      .detail{
        font-size:0.875rem;
        color: #666;
        text-align: left;
        .desc{
          display: flex;
          margin-bottom:1rem;
          .title{
            width:3.5rem;
            margin-right: 1.875rem;
            flex-shrink: 0;
          }
        }
      }
    }
    .el-divider--horizontal{
      margin:0.75rem 0;
    }
  }
</style>